import React from "react";
import Sider from "antd/es/layout/Sider";
import { Button, Menu, Avatar } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { ItemType } from "antd/es/menu/interface";

export interface SideBarProps {
  menuItems: ItemType[];
  collapsed: boolean;
  activeKey: string;
  openKey: string | null;
  isMobile: boolean;
  title: string;
  logoSrc?: string;
  onToggle: () => void;
  onSelect: (key: string) => void;
  onOpenChange: (keys: string[]) => void;
}

export const SideBar: React.FC<SideBarProps> = ({
  menuItems,
  collapsed,
  activeKey,
  openKey,
  isMobile,
  title,
  logoSrc = "/favicon.png",
  onToggle,
  onSelect,
  onOpenChange,
}) => {
  return (
    <Sider
      collapsible
      collapsed={collapsed}
      width={250}
      trigger={null}
      style={{ overflow: "auto", height: "100vh", position: "fixed", left: 0, top: 0, bottom: 0 }}
    >
      <div style={{ padding: 16, textAlign: "center", color: "white", fontSize: 22 }}>
        {collapsed ? <Avatar shape="square" src={logoSrc}></Avatar> : title}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        items={menuItems}
        openKeys={openKey ? [openKey] : []}
        onOpenChange={onOpenChange}
        selectedKeys={[activeKey]}
        onSelect={({ key }) => onSelect(key)}
      />

      {!isMobile && (
        <div style={{ position: "absolute", bottom: 10, width: "100%", textAlign: "center" }}>
          <Button 
            type="primary" 
            onClick={onToggle} 
            style={{ 
              width: "40px", 
              borderRadius: "10rem", 
              padding: "1.3rem", 
              display: 'inline-flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: '0 auto'
            }}
          >
            {collapsed ? <RightOutlined /> : <LeftOutlined />}
          </Button>
        </div>
      )}
    </Sider>
  );
};
